export default __webpack_public_path__ + "static/media/Samoore's Radiant Scripture.60bc98e0.jpg";